import { render } from "./AudioRecorder.vue?vue&type=template&id=682c92a6&scoped=true"
import script from "./AudioRecorder.vue?vue&type=script&lang=js"
export * from "./AudioRecorder.vue?vue&type=script&lang=js"

import "./AudioRecorder.vue?vue&type=style&index=0&id=682c92a6&scoped=true&lang=css"
import "./AudioRecorder.vue?vue&type=style&index=1&id=682c92a6&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-682c92a6"]])

export default __exports__